import { FILTER_FIELDS } from '@vlabs/monokit/entities/charts/chart-form';

const stringFields = [
  'tags',
  'external_id',
  'top_similar_external_id',
  'top_matching_candidates_label',
  'city',
  'area',
  'district',
  'street',
  'track_id',
  'user_data',
];

const normalizeValue = (value, fieldName = null) => {
  if (typeof value === 'string') {
    if (value === 'null') return null;

    const numberValue = parseFloat(value);

    if (fieldName && stringFields.includes(fieldName)) {
      return value;
    }

    if (!Number.isNaN(numberValue) && String(numberValue) === value.trim()) {
      return numberValue;
    }

    return value;
  }

  if (typeof value === 'number') {
    if (fieldName && stringFields.includes(fieldName)) {
      return String(value);
    }
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((item) => normalizeValue(item, fieldName));
  }

  return value;
};

export const prepareStatisticFilters = (filters = []) => {
  return filters.map((filter) => {
    const columnValue = filter.column;
    const operatorValue = filter.operator;
    const serverField = FILTER_FIELDS[columnValue]?.serverField ?? columnValue;

    const processedValue = normalizeValue(filter.value, columnValue);
    let value = processedValue;

    if (['like', 'nlike', 'in', 'nin'].includes(operatorValue)) {
      value = Array.isArray(processedValue) ? processedValue : [processedValue];
    }

    return {
      ...filter,
      column: serverField,
      value,
    };
  });
};
